(function () {
    'use strict';
    angular.module('app').component('habilTextField', {
        templateUrl: '@/textField/text-field.html',
        bindings: {
            text: '=',
            error: '@',
            isReadonly: '=',
            maxlength: '@',
            minlength: '@',
            required: '='
        },
        controller: TextFieldController
    });

    TextFieldController.$inject = ['translationsService'];
    function TextFieldController(translationsService) {
        const $controller = this;
        $controller.isValid = function () {
            return ($controller.required) ? $controller.text : true;
        };

        $controller.$onInit = initialize;

        $controller.errorMessage = () => {
            if ($controller.error) return $controller.error;
            if (!$controller.translations) return null;
            return $controller.translations.Form_Error_required;
        };

        function initialize() {
            // Load translations + title
            translationsService.loadTranslations(t => { $controller.translations = t; });
        }
    }
})();